module.exports = __webpack_public_path__ + "fonts/Nunito-900-vietnamese23.d858185.woff2";